<template>
  <div class="flex items-center gap-4">
    <slot name="before" :row="row"></slot>

    <button
      v-for="action in computedActions"
      :key="action.label"
      @click.stop="action.onClick"
      :class="[
        'text-[10px] font-black uppercase tracking-widest transition-colors flex items-center gap-1.5 group whitespace-nowrap',
        action.colorClass ||
          'text-slate-500 hover:text-slate-700 dark:text-slate-400 dark:hover:text-slate-200',
      ]"
    >
      <i
        :class="[
          action.iconClass,
          'transition-transform group-hover:scale-110',
        ]"
      ></i>
      {{ action.label }}
    </button>

    <slot name="after" :row="row"></slot>
  </div>
</template>

<script>
export default {
  name: "TableActions",
  props: {
    row: { type: Object, default: () => ({}) },
    // Default actions configuration
    showView: { type: Boolean, default: false },
    showEdit: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: false },
  },
  computed: {
    computedActions() {
      const actions = [];
      if (this.showView) {
        actions.push({
          label: this.$t("view"),
          iconClass: "fas fa-eye",
          colorClass:
            "text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300",
          onClick: () => this.$emit("view", this.row),
        });
      }
      if (this.showEdit) {
        actions.push({
          label: this.$t("edit"),
          iconClass: "fas fa-edit",
          colorClass:
            "text-green-500 hover:text-green-600 dark:text-green-400 dark:hover:text-green-300",
          onClick: () => this.$emit("edit", this.row),
        });
      }
      if (this.showDelete) {
        actions.push({
          label: this.$t("delete"),
          iconClass: "fas fa-trash-alt",
          colorClass:
            "text-red-500 hover:text-red-600 dark:text-red-400 dark:hover:text-red-300",
          onClick: () => this.$emit("delete", this.row),
        });
      }
      return actions;
    },
  },
};
</script>
